import AuthGuard from 'components/AuthGuard';
import LandingPage from 'components/LandingPage';
import LoadingComponent from 'components/LoadingComponent';
import EmbeddedBuild from 'pages/EmbeddedBuild';
import EventDashboard from 'pages/EventDashboard';
import EventLobby from 'pages/EventLobby';
import JoinEvent from 'pages/JoinEvent';
import QuickLink from 'pages/QuickLink';
import SignIn from 'pages/SignIn';
import SignInCallback from 'pages/SignInCallback';
import TeamAccountLogin from 'pages/TeamAccountLogin';
import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
    routeParams,
    routePaths,
    routes,
    UUID_V4_REG_EXP,
} from '../../constants';
import FallbackRoute from './FallbackRoute';

/**
 * This path will only work if routeParams.contentId has a correct V4 UUID
 */
export const workshopPath = `${routes.workshops}/:${routeParams.contentId}(${UUID_V4_REG_EXP})`;
/**
 * Prior to Feb 2022, our team supported embedded builds (/v2/workshops) and hugo builds (/workshops).
 * Hugo builds have been completely deprecated and our team only supports embedded builds.
 *
 * If a user navigates to /v2/workshops, redirect to /workshops. We are leaving the /v2 support just in case
 * users bookmarked their workshop and we do not want to break previous user experience.
 */
const deprecatedEmbeddedWorkshopPath = `${routes.embeddedWorkshops}/:${routeParams.contentId}(${UUID_V4_REG_EXP})`;

export const AppRoutes = () => {
    return (
        <Suspense
            fallback={<LoadingComponent containerProps={{ margin: 'm' }} />}>
            <Switch>
                <Route path={workshopPath} component={EmbeddedBuild} />
                <Route
                    path={deprecatedEmbeddedWorkshopPath}
                    render={({ location: { pathname, search, hash } }) => (
                        // remove /v2 prefix and preserve the rest of the route
                        <Redirect
                            to={{
                                pathname: pathname.replace(/^\/v2/, ''),
                                search,
                                hash,
                            }}
                        />
                    )}
                />
                <Route path={`${routes.events}/${routePaths.dashboard}`}>
                    <AuthGuard>
                        <EventDashboard />
                    </AuthGuard>
                </Route>
                <Route path={`${routes.events}/${routePaths.accountLogin}`}>
                    <AuthGuard>
                        <TeamAccountLogin />
                    </AuthGuard>
                </Route>
                <Route exact path={routes.lobby}>
                    <AuthGuard>
                        <EventLobby />
                    </AuthGuard>
                </Route>
                <Route exact path={routes.joinEvent}>
                    <AuthGuard>
                        <JoinEvent />
                    </AuthGuard>
                </Route>
                <Route
                    exact
                    path={routes.landingPage}
                    component={LandingPage}
                />
                <Route path={routes.signIn} exact>
                    <SignIn />
                </Route>
                <Route path={`${routes.callback}/${routePaths.login}`} exact>
                    <SignInCallback />
                </Route>
                <Route exact path={routes.notFound} component={FallbackRoute} />
                <Route
                    path={`/:${routeParams.quickLinkId}`}
                    component={QuickLink}
                />
                <Route path="*" component={FallbackRoute} />
            </Switch>
        </Suspense>
    );
};
